import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.find-index";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Vue from 'vue';
import { loadImgBlob } from "./helper";

function appendUrl(url) {
  if (url.indexOf('imgLoad=1') >= 0) {
    return url;
  } else {
    return url + (url.indexOf('?') >= 0 ? '&imgLoad=' : '?imgLoad=') + '1';
  }
}

function collectImagesUrl() {
  var vnodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var images = arguments.length > 1 ? arguments[1] : undefined;

  var _iterator = _createForOfIteratorHelper(vnodes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var vnode = _step.value;

      if (vnode.tag === 'img') {
        if (vnode.data.attrs.src.indexOf('data:') !== 0) {
          images.push(appendUrl(vnode.data.attrs.src));
        }
      } else if (vnode.children) {
        collectImagesUrl(vnode.children, images);
      } else if (vnode.componentOptions) {
        var subComp = new vnode.componentOptions.Ctor({
          _isComponent: true,
          _parentVnode: vnode
        });

        var subVnode = subComp._render(); // console.log(subVnodes)


        collectImagesUrl([subVnode], images);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function replaceImageUrl(vnodes, imgLoadData) {
  var _iterator2 = _createForOfIteratorHelper(vnodes),
      _step2;

  try {
    var _loop = function _loop() {
      var vnode = _step2.value;

      if (vnode.tag === 'img') {
        // 需要把插入dom的img元素的crossOrigin 设置为 'Anonymous'，
        // 避免因为crossOrigin和预加载的不同而导致发送不同的图片请求
        if (vnode.data.attrs.src.indexOf('data:') !== 0) {
          vnode.data.attrs.src = appendUrl(vnode.data.attrs.src);
          vnode.data.attrs.crossOrigin = 'Anonymous';
        }

        var index = imgLoadData.images.findIndex(function (item) {
          return item === vnode.data.attrs.src;
        });
        var targetSrc = imgLoadData.base64s[index];

        if (index >= 0 && targetSrc) {
          vnode.data.attrs.src = targetSrc;
        }
      } else if (vnode.children) {
        replaceImageUrl(vnode.children, imgLoadData);
      }
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

function findImgLoad(instance) {
  if (!instance) return;

  if (instance.imgLoadData) {
    return instance;
  } else if (instance.$parent !== instance) {
    return findImgLoad(instance.$parent);
  }
}

Vue.mixin({
  beforeMount: function beforeMount() {
    var _arguments = arguments,
        _this = this;

    var imgLoad = findImgLoad(this);
    if (!imgLoad || imgLoad === this) return;
    var _render = this._render;

    this._render = function () {
      var vnode = _render.apply(_this, Array.from(_arguments));

      replaceImageUrl([vnode], imgLoad.imgLoadData);
      return vnode;
    };
  }
});
var errorImgs = [];
export default {
  name: 'ImgLoad',
  props: {
    // 是否在加载图片过程中渲染dom
    visibleOnLoad: {
      type: Boolean,
      default: false
    },
    // 重试次数
    retry: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      isLoaded: false,
      renderAfterLoaded: false,
      imgLoadData: {
        images: [],
        base64s: []
      }
    };
  },
  // eslint-disable-next-line
  render: function render(h) {
    var _this2 = this;

    var vnodes = this.$slots.default;

    if (!this.isCollected) {
      this.isCollected = true;
      var images = [];
      collectImagesUrl(vnodes, images);
      this.$nextTick(function () {
        _this2.imgLoadData.images = images;

        _this2.preloadImages();
      });
    } // 因为vnodes 一直是同一个this.$slots.default对象，
    // 导致在vue内部patch时，preVnode和vnode是同一个对象
    // vue不会更新dom，这里是为了触发vue去更新
    // 在loaded后需要先返回false，nextTick后再返回vnode


    if (this.isLoaded && !this.renderAfterLoaded) {
      this.$nextTick(function () {
        _this2.renderAfterLoaded = true;
      });
      return false;
    }

    if (this.visibleOnLoad || this.isLoaded) {
      replaceImageUrl(vnodes, this.imgLoadData);
      return vnodes;
    } else {
      return false;
    }
  },
  methods: {
    preloadImage: function () {
      var _preloadImage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
        var tryTime, retryUrl, error;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tryTime = 1;
                retryUrl = url;

              case 2:
                if (!(tryTime <= this.retry + 1)) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return loadImgBlob(retryUrl);

              case 6:
                return _context.abrupt("return", _context.sent);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                error = _context.t0;
                errorImgs.push(url);
                retryUrl = url + '&retry=' + Date.now();
                tryTime++;

              case 15:
                _context.next = 2;
                break;

              case 17:
                if (!error) {
                  _context.next = 20;
                  break;
                }

                console.error(error);
                throw new Error("image download failed, try ".concat(this.retry + 1, " times, ").concat(url));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function preloadImage(_x) {
        return _preloadImage.apply(this, arguments);
      }

      return preloadImage;
    }(),
    preloadImages: function () {
      var _preloadImages = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var base64s;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return Promise.all(this.imgLoadData.images.map(function (url) {
                  return _this3.preloadImage(url);
                }));

              case 3:
                base64s = _context2.sent;
                this.imgLoadData.base64s = base64s;
                this.isLoaded = true;
                this.$nextTick(function () {
                  _this3.$nextTick(function () {
                    _this3.$nextTick(function () {
                      _this3.$emit('load');
                    });
                  });
                });
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);
                this.$emit('error', _context2.t0);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function preloadImages() {
        return _preloadImages.apply(this, arguments);
      }

      return preloadImages;
    }()
  }
};